var _AggregateDisposable_disposed, _AggregateDisposable_disposables;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import AlreadyDisposedException from './Exceptions/AlreadyDisposedException';
import Exception from './Exceptions/Exception';
import ErrorException from './Exceptions/ErrorException';
/** A Disposable that can collect disposable objects and dispose then when it is disposed */
export default class AggregateDisposable {
    constructor(...disposables) {
        _AggregateDisposable_disposed.set(this, false);
        _AggregateDisposable_disposables.set(this, void 0);
        __classPrivateFieldSet(this, _AggregateDisposable_disposables, disposables, "f");
    }
    /** Disposes the objects tracked by this */
    dispose() {
        __classPrivateFieldSet(this, _AggregateDisposable_disposed, true, "f");
        for (const disposable of __classPrivateFieldGet(this, _AggregateDisposable_disposables, "f")) {
            try {
                return disposable.dispose();
            }
            catch (ex) {
                if (!(ex instanceof AlreadyDisposedException)) {
                    if (ex instanceof Exception) {
                        throw new Exception("An error occured while disposing an object", ex);
                    }
                    else if (ex instanceof Error) {
                        throw new Exception("An error occured while disposing an object", new ErrorException(ex));
                    }
                    else {
                        throw new Exception(`An error occured while disposing an object: '${ex}'`);
                    }
                }
            }
        }
    }
    track(disposable) {
        if (__classPrivateFieldGet(this, _AggregateDisposable_disposed, "f")) {
            throw new AlreadyDisposedException();
        }
        __classPrivateFieldGet(this, _AggregateDisposable_disposables, "f").push(disposable);
    }
    async disposeAsync() {
        return new Promise((resolve, reject) => {
            try {
                for (const disposable of __classPrivateFieldGet(this, _AggregateDisposable_disposables, "f")) {
                    disposable.dispose();
                }
                resolve();
            }
            catch (ex) {
                reject(ex);
            }
        });
    }
}
_AggregateDisposable_disposed = new WeakMap(), _AggregateDisposable_disposables = new WeakMap();
